import PropTypes from "prop-types";
import {
    Backdrop,
    Button, ButtonGroup,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader, CircularProgress, Divider,
    IconButton,
    Typography
} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import AddIcon from "@mui/icons-material/Add";
import {Link} from "react-router-dom";
import {useState} from "react";

FacultyStatementCard.propTypes = {
    statementId: PropTypes.number,
    statementNumber: PropTypes.string,
    closingDate: PropTypes.string,
    orderNumber: PropTypes.number,
    canCreate: PropTypes.bool,
    sessionDisciplineDetailId: PropTypes.number,
    eventDateTime: PropTypes.string,
    passingType: PropTypes.number,
    controlType: PropTypes.number,
    facultyName: PropTypes.string,
    previousClosed: PropTypes.bool,
    hasDebtors: PropTypes.bool
}

export default function FacultyStatementCard(props){
    const baseUrl = localStorage.getItem("baseUrl");
    const isClosed = props.closingDate !== null && props.closingDate !== undefined;
    const roles = localStorage.getItem('roles').split(',');
    const isUmu = roles.find((item) => item === 'AttNewUmu') !== undefined;
    const isDispatcher = roles.find((item) => item === 'AttNewDispatcher') !== undefined;
    const [draftIsLoading, setDraftIsLoading] = useState(false);
    const [dekanatStatementReportIsLoading, setDekanatStatementReportIsLoading] = useState(false);
    const isFaculty = roles.find((item) => item === 'faculty') !== undefined;

    function toDateString(date){
        if (date === null)
            return '';
        
        return new Date(date).toLocaleDateString("ru-RU");
    }

    function getNotCreatedStatementCard(props) {

        const msg = [];

        if (!props.canCreate) {
            return <Typography fontSize="small">Ведомость не требуется</Typography>;
        }

        if ((props.sessionDisciplineDetailId === 0 || props.sessionDisciplineDetailId === null || props.sessionDisciplineDetailId === undefined) ||
            ((props.eventDateTime === undefined || props.eventDateTime === null) && props.controlType !== 3 && props.controlType !== 4)) {
            msg.push(<Typography fontSize="small">Нет даты пересдачи</Typography>);
        }

        if (!props.previousClosed || props.previousClosed === null || props.previousClosed === undefined) {
            msg.push(<Typography fontSize="small">Для создания ведомости необходимо закрыть предыдущую</Typography>);
        }
        
        if (props.hasDebtors) {
            msg.push(<Typography fontSize="small">В предыдущей ведомости имеются задолжники</Typography>);
        }

        if (msg.length > 0) {
            return msg;
        }

        if (isItMoreThan1DayFromNow(props.eventDateTime) && props.controlType === 0 && (props.passingType === 0 || props.passingType === 1) && props.facultyName !== 'Факультет заочного обучения') {
            return <strong>Ведомость выписывается не раньше, чем за 1 рабочий день до начала сроков проведения ({new Date(props.eventDateTime).toLocaleDateString('ru-RU')})</strong>;
        }

        return (

            <>
                <strong>Дата проведения: {new Date(props.eventDateTime).toLocaleDateString('ru-RU')}</strong>

                <br />
                <br />

                {isFaculty
                    ? <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        href={`/createstatement/${props.sessionDisciplineDetailId}`}> Создать</Button>
                    : <>Ведомость не создана</>}
            </>

        );
    }
    
    function printDekanatStatementReport() {
        setDekanatStatementReportIsLoading(true);
        fetch(`/Reports/DekanatStatementReport?statementId=${props.statementId}&fileType=pdf`,
            {
                method: "GET",
                headers: { "semesterid": localStorage.getItem("selectedSemesterId"), "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem('token')}`}
            }).then(response => {
            setDekanatStatementReportIsLoading(false);
            return response.blob();
        }).then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Отчет.pdf`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
    }
    
    function downloadStatementDraft() {
        setDraftIsLoading(true);
        fetch(`/Reports/StatementDraft?statementId=${props.statementId}&fileType=pdf`,
            {
                method: "GET",
                headers: { "semesterid": localStorage.getItem("selectedSemesterId"), "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem('token')}`}
            }).then(response => {
                setDraftIsLoading(false);
                return response.blob();
        }).then(response => {
                const url = window.URL.createObjectURL(
                    new Blob([response]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `Справочная ведомость.pdf`,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);
            })
    }

    function isItMoreThan1DayFromNow(eventDateTime) {

        const eventDay = new Date(eventDateTime);

        // Calculate the date one day before the event date
        const dayBefore = new Date(eventDay);
        dayBefore.setDate(eventDay.getDate() - 1);
        dayBefore.setHours(0, 0, 0, 0);

        // Get today's date with time set to midnight
        const today = new Date();
        today.setHours(0, 0, 0, 0);        

        // Check if today is before the day before the event date
        return today.getTime() < dayBefore.getTime();
    }

    return (
        <Card variant="outlined">
            <CardContent>

                {props.statementId > 0
                    ?
                    <>
                        <Typography variant="h6">{props.closingDate !== undefined
                            ? `${(props.closingDate !== null ? 'Закрытая' : 'Открытая')} ведомость`
                            : <></>} № {props.statementNumber}</Typography>

                        <br />

                        {props.closingDate !== null && +props.eventDateTime !== 0 ? <>
                            <strong>Дата проведения: {new Date(props.eventDateTime).toLocaleDateString('ru-RU')}</strong>
                        </> : <></>} 

                        <ButtonGroup size="small" orientation="vertical">
                            <Button startIcon={<InsertDriveFileOutlinedIcon />}
                                href={`/statementresults/${props.statementId}`}>Подробности и результаты</Button>

                            {props.closingDate == null && !isUmu && !isDispatcher && (
                                <Button startIcon={<EditIcon />}
                                    href={`/editfacultystatement/${props.statementId}`}>Изменить ведомость</Button>
                            )}

                            <Button startIcon={<PrintIcon />}
                                disabled={draftIsLoading}
                                onClick={() => downloadStatementDraft()}>Справочная ведомость</Button>

                            <Button startIcon={dekanatStatementReportIsLoading ? <CircularProgress size={15} /> : <PrintIcon />} onClick={() => printDekanatStatementReport()}>Отчет</Button>

                        </ButtonGroup>                      

                    </> :
                    <>
                        {getNotCreatedStatementCard(props)}
                    </>
                }

                {draftIsLoading
                ? <>
                        <Divider/>
                        <br/>
                        <CircularProgress size={"2rem"}/>
                    </>
                    : <></>}
            </CardContent>
        </Card>
    )
}